import React from 'react';
import { Router, useRouterHistory, applyRouterMiddleware } from 'react-router';
import { hydrate } from 'react-dom';
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import { AppContainer } from 'react-hot-loader';
import { createHistory } from 'history';
import { useScroll } from 'react-router-scroll';
import EdeQueryProvider from 'routes/marketplace-ede/context/edeQueryProvider';
import { getApolloClient } from './apolloClient';
import routerRoutes from './components/routes';
import configureStore from '../configureStore';
import * as rootReducer from './reducers';
import { BASE_NAME } from './base';

const store = configureStore(rootReducer, {
  client: true,
  initialData: window.__INITIAL_STATE__,
});

const RenderApp = (routes) => {
  hydrate(
    <ApolloProvider client={getApolloClient()}>
      <AppContainer>
        <Provider store={store}>
          <EdeQueryProvider>
            <Router
              history={useRouterHistory(createHistory)({
              basename: `/${BASE_NAME}`,
            })}
              routes={routes}
              render={applyRouterMiddleware(useScroll(() => [0, 0]))} />
          </EdeQueryProvider>
        </Provider>
      </AppContainer>
    </ApolloProvider>,
    document.getElementById(`${BASE_NAME}-root`),
  );
};

RenderApp(routerRoutes);

if (module.hot) {
  module.hot.accept('./components/routes', () => {
    // eslint-disable-next-line global-require
    const newRoutes = require('./components/routes').default;
    RenderApp(newRoutes);
  });
}

export const bundleName = BASE_NAME;
